"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Label = (0, _styledBase["default"])("span", {
  target: "e1gg6e9u0",
  label: "Label"
})(process.env.NODE_ENV === "production" ? {
  name: "f423mp",
  styles: "font-size:13px;padding-left:10px;color:#333333;"
} : {
  name: "f423mp",
  styles: "font-size:13px;padding-left:10px;color:#333333;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2ljb24tYnV0dG9uL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUt5QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9pY29uLWJ1dHRvbi9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcclxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XHJcbmltcG9ydCB7IExpbmsgfSBmcm9tIFwicmVhY3Qtcm91dGVyLWRvbVwiO1xyXG5pbXBvcnQgeyBGb250QXdlc29tZUljb24gfSBmcm9tIFwiQGZvcnRhd2Vzb21lL3JlYWN0LWZvbnRhd2Vzb21lXCI7XHJcblxyXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5zcGFuYFxyXG4gIGZvbnQtc2l6ZTogMTNweDtcclxuICBwYWRkaW5nLWxlZnQ6IDEwcHg7XHJcbiAgY29sb3I6ICMzMzMzMzM7XHJcbmA7XHJcblxyXG5jb25zdCBTdHlsZWRMaW5rID0gc3R5bGVkKExpbmspYFxyXG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xyXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbmA7XHJcblxyXG5jb25zdCBJY29uQnV0dG9uID0gKHsgZGF0YVRlc3QsIGxhYmVsIH0pID0+IChcclxuICA8U3R5bGVkTGluayBkYXRhLXRlc3Q9e2RhdGFUZXN0fSB0bz1cIi9hZGRhY2NvdW50bGlua1wiIGNsYXNzTmFtZT1cImxpbmtfYWRkXCI+XHJcbiAgICA8Rm9udEF3ZXNvbWVJY29uIGljb249XCJwbHVzLXNxdWFyZVwiIC8+XHJcbiAgICA8TGFiZWw+e2xhYmVsfTwvTGFiZWw+XHJcbiAgPC9TdHlsZWRMaW5rPlxyXG4pO1xyXG5cclxuZXhwb3J0IGRlZmF1bHQgSWNvbkJ1dHRvbjtcclxuIl19 */"
});
var StyledLink = (
/*#__PURE__*/
0, _styledBase["default"])(_reactRouterDom.Link, {
  target: "e1gg6e9u1",
  label: "StyledLink"
})(process.env.NODE_ENV === "production" ? {
  name: "18biwo",
  styles: "display:inline-flex;align-items:center;"
} : {
  name: "18biwo",
  styles: "display:inline-flex;align-items:center;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2ljb24tYnV0dG9uL2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVcrQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9pY29uLWJ1dHRvbi9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcclxuaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XHJcbmltcG9ydCB7IExpbmsgfSBmcm9tIFwicmVhY3Qtcm91dGVyLWRvbVwiO1xyXG5pbXBvcnQgeyBGb250QXdlc29tZUljb24gfSBmcm9tIFwiQGZvcnRhd2Vzb21lL3JlYWN0LWZvbnRhd2Vzb21lXCI7XHJcblxyXG5jb25zdCBMYWJlbCA9IHN0eWxlZC5zcGFuYFxyXG4gIGZvbnQtc2l6ZTogMTNweDtcclxuICBwYWRkaW5nLWxlZnQ6IDEwcHg7XHJcbiAgY29sb3I6ICMzMzMzMzM7XHJcbmA7XHJcblxyXG5jb25zdCBTdHlsZWRMaW5rID0gc3R5bGVkKExpbmspYFxyXG4gIGRpc3BsYXk6IGlubGluZS1mbGV4O1xyXG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XHJcbmA7XHJcblxyXG5jb25zdCBJY29uQnV0dG9uID0gKHsgZGF0YVRlc3QsIGxhYmVsIH0pID0+IChcclxuICA8U3R5bGVkTGluayBkYXRhLXRlc3Q9e2RhdGFUZXN0fSB0bz1cIi9hZGRhY2NvdW50bGlua1wiIGNsYXNzTmFtZT1cImxpbmtfYWRkXCI+XHJcbiAgICA8Rm9udEF3ZXNvbWVJY29uIGljb249XCJwbHVzLXNxdWFyZVwiIC8+XHJcbiAgICA8TGFiZWw+e2xhYmVsfTwvTGFiZWw+XHJcbiAgPC9TdHlsZWRMaW5rPlxyXG4pO1xyXG5cclxuZXhwb3J0IGRlZmF1bHQgSWNvbkJ1dHRvbjtcclxuIl19 */"
});

var IconButton = function IconButton(_ref) {
  var dataTest = _ref.dataTest,
      label = _ref.label;
  return _react["default"].createElement(StyledLink, {
    "data-test": dataTest,
    to: "/addaccountlink",
    className: "link_add"
  }, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: "plus-square"
  }), _react["default"].createElement(Label, null, label));
};

var _default = IconButton;
exports["default"] = _default;